import { stylesheet } from 'typestyle';

const styles = stylesheet({
  displayFlexWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 30,
  },
});

export default styles;
